import { CartAddEvent } from '@theme/events';

class LmdsCartUpsell extends HTMLElement {
  #list = null;
  #frame = 0;

  connectedCallback() {
    this.addEventListener('submit', this.#onSubmit);
    this.#list = this.querySelector('.cart-upsell__list');
    if (this.querySelector('.cart-upsell__dots')) {
      this.#list?.addEventListener('scroll', this.#onScroll, { passive: true });
    }
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.#onSubmit);
    this.#list?.removeEventListener('scroll', this.#onScroll);
    cancelAnimationFrame(this.#frame);
  }

  #onScroll = () => {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => {
      const list = this.#list;
      if (!list) return;
      const items = Array.from(list.children);
      const center = list.scrollLeft + list.clientWidth / 2;
      let active = 0;
      let distance = Infinity;
      items.forEach((item, index) => {
        if (!(item instanceof HTMLElement)) return;
        const itemCenter = item.offsetLeft + item.offsetWidth / 2;
        const gap = Math.abs(itemCenter - center);
        if (gap < distance) {
          distance = gap;
          active = index;
        }
      });
      this.querySelectorAll('.cart-upsell__dot').forEach((dot, index) => {
        dot.classList.toggle('is-active', index === active);
      });
    });
  };

  #onSubmit = async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('.cart-upsell__error');

    if (button?.getAttribute('aria-busy') === 'true') return;

    button?.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;

    const sectionIds = new Set();
    document.querySelectorAll('cart-items-component').forEach((element) => {
      if (element instanceof HTMLElement && element.dataset.sectionId) {
        sectionIds.add(element.dataset.sectionId);
      }
    });

    const body = new FormData(form);
    body.append('sections', Array.from(sectionIds).join(','));
    body.append('sections_url', window.location.pathname);

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body,
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || '');
      }

      this.dispatchEvent(
        new CartAddEvent({}, String(body.get('id')), {
          source: 'product-form-component',
          itemCount: 1,
          sections: data.sections,
        })
      );
    } catch (failure) {
      if (error) {
        error.textContent = failure instanceof Error && failure.message ? failure.message : '';
        error.hidden = !error.textContent;
      }
      button?.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('lmds-cart-upsell')) {
  customElements.define('lmds-cart-upsell', LmdsCartUpsell);
}
